module.exports = __webpack_public_path__ + "static/media/Benifits1.b2d9ff65.webp";